import React from 'react';
import PropTypes from 'prop-types';
import Vimeo from '@u-wave/react-vimeo';
// import ReactJWPlayer from 'react-jw-player';
import { connect } from 'react-redux';
import ReactPlayer from "react-player"
import LoadingComponent from "./../../components/LoaderComponent";
const displayName = 'ReactJWPlayerContainer';
const width = window.innerWidth;


class ReactJWPlayerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoTitle: '',
      playlist:null,
      errorMessage: '',
      error: false,
      loading:true
    };
 
    this.onAdPlay = this.onAdPlay.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
 
    // each instance of <ReactJWPlayer> needs a unique id.
    // we randomly generate it here and assign to the container instance.
    // this.playerId = someFunctionToRandomlyGenerateId();
  }
  componentDidMount(){

    const{  url, formLibrary, mentor_name,
      jwPlayerPlaylist, isJwPlayer, isMediaId, isLive, showToaster, facultyInfo, isPlayerError} = this.props;
    const { title, mediaid=null, image, description, sources=[] } = jwPlayerPlaylist || {};
    
    const _file = sources?.length > 0 && sources[0]?.file || '';

    this.setState({
      playlist : (isMediaId || isLive) ?  this.props.jwPlayerPlaylist :  [{
        
        file:  url,
        // image: 'https://link-to-my-poster.jpg',
        image: 'this.props.sourceFileInfo && this.props.sourceFileInfo.image',
        tracks: [{
          // file: 'https://link-to-subtitles.vtt',
          label: this.props.sourceFileInfo && this.props.sourceFileInfo.title,
          kind: 'captions',
          'default': true
        }],
      },
      {
        // file: 'https://link-to-my-other-video.mp4',
        // image: 'https://link-to-my-other-poster.jpg',
      }]
    })
   
  }

  onReady(event) {
    // interact with JW Player API here
    const player = window.jwplayer('my-unique-id');
  }
  onAdPlay(event) {
    // track the ad play here
  }
  onVideoLoad(event) {
    this.setState({
      videoTitle: event.item.description // this only works with json feeds!
    });
  }
  render() {
    const { isUrlTrue, url, isMediaId } = this.props;
    
    return (
      <div className='react-jw-player-container' style={{textAlign:'center'}}>
        { 
        this.state.loading && isMediaId &&
            <div
            style={{
              width: '100%',
              height: '100%',
              display:'flex',
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingComponent styles={{width: 250, height: 250}} />                    

          </div>
        }
        
                {
                 !(isMediaId) ?
                  <ReactPlayer
                    className='react-player'
                    url={url}
                    width={width <= 780 ? '100%' : '100%'}
                    height={width <= 780 ? 300 : 600}
                    controls={true}
                    playing={true}
                    config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                  />
            :
            (
                <Vimeo
                video={`https://vimeo.com/${url}`}
                autoplay={true}
                  loop
                muted={false}
                showPortrait
                background={false}
                controls={true}
                style={{ marginLeft: width <= 780 ? 15 : 0}}
                width={width <= 780 ? 360 : 800}
                height={width <= 780 ? 300 : 600}
                onLoaded={() => {
                  this.setState({
                    loading: false
                  })
                }}
                onError={() => {
                  this.setState({
                    errorMessage: 'There is no live classes today',
                    error: true
                  })
                }}
      
              />
              
            )

         }
         {
            this.state.error &&
            <div style={{ width: '100%', height:'100%', alignSelf: 'center',  display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <h4>Not Found</h4>
            </div> 
        }
      </div>
    );
  } 
}
 
const mapStatesToProps = state => ({
  sourceFileInfo: state.JwPlayerSourceInfo && state.JwPlayerSourceInfo.response && state.JwPlayerSourceInfo.response.playlist[0]
})

export default connect(mapStatesToProps, {})(ReactJWPlayerContainer);